import * as React from 'react'

import {productSpecs} from '../master'
import {Product} from "../components/Product/Product";

const LogoImage = require('../images/logo.svg')

const Index: React.FC = () => {
  return <div className="pt-10 subpixel-antialiased" style={{backgroundColor: "#EEE9D1", fontFeatureSettings: "palt"}}>
    <h1>
      <img className="w-2/5 m-auto lg:w-56" src={LogoImage} alt="PowerArQ"/>
    </h1>
    <h2 className="mt-2 text-center">
      比較表
    </h2>
    <section className="py-4">
      <h3 className="text-center text-2xl font-bold pt-3 pb-6">PowerArQシリーズを<br className="lg:hidden"/>徹底比較！</h3>
      <p className="px-8 pb-4 text-sm leading-7 lg:text-center">
        PowerArQ ポータブル電源は大容量バッテリーであり、<br className="hidden lg:inline"/>
        AC出力やUSB出力できるという基本機能は同じで、<br className="hidden lg:inline"/>
        容量（ご使用になりたい機器や使用時間）や大きさ、ご予算が比較のポイントになります。
      </p>
      <p className="px-8 pb-4 text-sm leading-7 lg:text-center">
        どのように利用するかを考えながら、<br className="hidden lg:inline"/>
        あなたにピッタリのPowerArQを選んでみてください。
      </p>
      <p className="w-4/5 m-auto text-xs lg:text-center lg:leading-7 lg:w-full lg:m-0 lg:text-xs lg:col-span-4">
        ※使用時間（回数）は目安（理論値）です。<br/>
        ※製品の性質上、使用製品の仕様や周辺の温度環境、バッテリーの劣化具合により時間や回数の目安は変動します。
      </p>
    </section>
    <div className="w-full overflow-x-auto">
      <div className="overflow-x-auto m-auto flex py-5 grid-cols-6 lg:gap-4 lg:max-w-screen-xl">
        {productSpecs.map((product) =>
          <Product
            key={product.id}
            product={product}
          />
        )}
      </div>
    </div>
  </div>
}

export default Index
